// extracted by mini-css-extract-plugin
module.exports = {"container":"TransferGraph_container__W87t8","graphTitle":"TransferGraph_graphTitle__qt3ki","graph":"TransferGraph_graph__p5E_H"};